<template>

  <div style="padding-bottom: 0px;" class="vip"  >



<div class="vip__wrap" v-if="data">
   
<div class="tp">
     <a href="#buy1" id="buy">
     <img src="/images/vv1.png" alt="">
     </a>
</div>


<div class="tp">
     <img src="/images/vv2.png" alt="">
     
</div>

<!--
<swiper
      :options="swiperOption"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      class="s1"
>
    
      <swiper-slide>
<div class="imgCont"><img src="http://adm56.51lihaoedu.top/back/uploads/20220101/b6fe60f7c241834fa9a3e7ca9619edb1.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">情商EQ测试-标准版</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"><img src="http://adm56.51lihaoedu.top/back/uploads/20220101/4bef877657b320e95ac840e5124bf9aa.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">逆商测试【标准版】</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"> <img src="http://adm56.51lihaoedu.top/back/uploads/20220101/7be8d4a79cf346e4bdde48912928793b.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">MBTI职业性格测试</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"><img src="http://adm56.51lihaoedu.top/back/uploads/20220101/e5b1743ee3823fb524e0e4e80a152a26.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">综合心理健康评估(SCL-90)</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"> <img src="http://adm56.51lihaoedu.top/back/uploads/20220101/a5206aeacd588b44268361a8fec42c81.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">抑郁程度自评</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"><img src="http://adm56.51lihaoedu.top/back/uploads/20220101/b127f13a6c9ab836688f6e3d0755e504.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">焦虑指数测试</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"> <img src="http://adm56.51lihaoedu.top/back/uploads/20220101/90330e0c592c83b0e5f8efdd5a98b755.jpg"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">潜意识画像测试</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"> <img src="http://adm56.51lihaoedu.top/back/uploads/20211223/63e677c5d0efa2b0a24636dcbd00c6f1.png"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">自尊心测试</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"><img src="https://imgco.xinli001.com/ceping/lingxi/scalePool/2f0c3eaca652408c899f5c502944c022.png?x-oss-process=image/resize,p_60/quality,Q_80"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">大脑年龄测试</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
        
      <swiper-slide>
<div class="imgCont"><img src="http://adm56.51lihaoedu.top/back/uploads/20211222/c24753505cd6acf51fa06f71e894a7e9.png"> <div class="mask"></div> <div class="testedPeople">2017人已测</div> <p class="title"></p></div>
<div class="desc">内心恐惧投射</div> 
<div class="vs">
<img src="/images/vs.png" alt="">
</div>
 </swiper-slide>
    
 




   
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    
        
</swiper>
-->

<div class="tp">
     <img src="/images/vv3-1.png" alt="">
</div>


<div class="gd">
<div class="gdt">
  360°综合心里评估<br>
  给你的心做个全方位扫描
</div>
<swiper
      :options="swiperOption1"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      class="s2"
>
    
      <swiper-slide>
<img src="https://adm56.51lihaoedu.top/back/uploads/20211017/07b0f1722e04704f35fa556a0b0f6184.png" alt="">
 </swiper-slide>
    
            <swiper-slide>
<img src="https://adm56.51lihaoedu.top/back/uploads/20220101/dcd3267ef7773e9342ee527c8fc66e46.jpg" alt="">
 </swiper-slide>
 
     <swiper-slide>
<img src="https://adm56.51lihaoedu.top/back/uploads/20211109/c1689642c782d421bbed29df5d2dc679.jpg" alt="">
 </swiper-slide>


    
        <div class="swiper-pagination" slot="pagination"></div>
    
   
</swiper>
</div>



<div class="tp">
     <img src="/images/vv3-2.png" alt="">
</div>

<div class="buyvip" id="buy1" >
  <div class="switch-bar" >
          <div v-bind:class="(active==0)?'item active':'item'"  v-on:click='qh(0)'>
      <span >V1普通会员</span>
     </div>
     <div v-bind:class="(active==1)?'item active':'item'"  v-on:click='qh(1)'>
      <span >V2白银会员</span>
     </div>
     <div v-bind:class="(active==2)?'item active':'item'"  v-on:click='qh(2)'>
      <span >V3黄金会员</span>
     </div>
    <div v-bind:class="(active==3)?'item active':'item'"  v-on:click='qh(3)'>
      <span >V4钻石会员</span>
     </div>
    </div>




<van-tabs v-model="active" animated swipeable >
  <van-tab title="标签 1">
      <div class="hyk k1">
      <div class="cardbg ptcard">
<img src="/images/k1.png" alt="">

<!--
      <h4>V1普通会员</h4>
      <div class="infoline">高性价比的明智之选</div>
-->
      
      </div>
</div>

      </van-tab>
  <van-tab title="标签 2">
     <div class="hyk k2">
      <div class="cardbg ptcard">

   <img src="/images/k2.png" alt="">


      </div>
</div>

  </van-tab>
  <van-tab title="标签 3">
     <div class="hyk k3">
      <div class="cardbg ptcard">

   <img src="/images/k3.png" alt="">
      
      
      </div>
</div>

  </van-tab>
  <van-tab title="标签 4">
     <div class="hyk k0">
      <div class="cardbg ptcard">

<img src="/images/k0.png" alt="">

      </div>
</div>

  </van-tab>
</van-tabs>




<div class="type-wrap mainContent" id="content-wrapper">

            <div class="type-item type-item__normal tab-content swiper-containerx current" id="tab-2" style="padding:15px;box-sizing:border-box;line-height:.27rem;">
             <div class="tab0" v-if="active==0">
         <div v-html="data['0'].content">  </div>
             </div>
             <div class="tab1" v-if="active==1">
                 <div v-html="data['1'].content">  </div>
             </div>
             <div class="tab2" v-if="active==2">
              <div v-html="data['2'].content">  </div>
             </div>
             <div class="tab3" v-if="active==3">
            <div v-html="data['3'].content">  </div>
             </div>
            </div>
           
    </div>






<div class="pay-block bottompay pay-2" style="display: block;" v-if="yhj">
<div class="yhj" v-if="yhj.code==1" @click="use()">
    <span class="yhj_z">
    <input type="checkbox" name="" id="yh" v-model="yh_check"> 
    <b>使用VIP {{ yhj.zhe }}元优惠劵</b> 
 </span>
 <span class="sx">距离失效：{{ djs }}</span>
</div>
    <div class="inner">
        <div class="left-price-label">
            

<p class="yj"><span>¥{{data[active].price*2 }}</span>/年</p>
<p>
                <span  class="price-label no2 normal apply" style="font-size:.3rem;color:#ff5757;" price="199">¥{{data[active].price}}</span>
             
                <span style="font-size:14px;" v-if="active!=3">/年</span>
        
            </p>


         
        </div>

        <div class="right-price-label" @click='buyvip' data-type="13" >

<div class="text">
  立即开通{{ data[active].title  }}
</div>
        </div>
    
    </div>
</div>


</div>


<!--
<div class="tp">
     <img src="/images/v8.png" alt="">
</div>

<div class="tp">
     <img src="/images/v9.png" alt="">
</div>
-->
















</div>



<qipao></qipao>


  </div>
</template>


<style lang="less" scoped>
.yhj_z{display:flex;    align-items: center;
input{background:#fff;}


}
.yhj{background: #fc6935;color:#fff;height:.27rem;line-height: 0.27rem;padding: 0px .1rem;
box-sizing: border-box;    display: flex;justify-content: space-between;
.sx{font-size:.12rem;}
}
</style>


<script>
import Foot from './../Foot'
import Vue from 'vue';
import { Lazyload } from 'vant';
import { Tab, Tabs } from 'vant';
import { Loading } from 'vant';
import qipao from './../../components/part/qipao';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import { ActionSheet } from 'vant';
import { Toast } from 'vant';
import { RadioGroup, Radio } from 'vant';

Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Toast);
Vue.use(ActionSheet);
Vue.use(Loading);
import global from './../common.vue'
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
 // Import Swiper Vue.js components



export default {
    data() {
        return {
            data:null,
            djs:'',
            sjc:null,
            active:0,
              loading:1,
              url:'',
               r:document.URL,
             vipshow: false,
                   yhj:null,
                   vipuser:null,
                   yh_check:false,
             actions: [
        { name: '选项一' },
        { name: '选项二' },
        { name: '选项三', subname: '描述信息' },
      ],
                  swiperOption: {
        slidesPerView: 3,
        // 设置分页器  
        loop: true,
        speed:2000,//匀速时间
        /*
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        */
        // 设置自动轮播
    autoplay: {
	    	delay: 0,
	    	stopOnLastSlide: false,
	    	disableOnInteraction: false,
	    },

      }
    ,
                  swiperOption1: {
     slidesPerView: 1,
      spaceBetween: 0,
	  centeredSlides: true,
       loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
    },

        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
 

      }

        }
    },
    components:{
     Foot,
     qipao
    }, 
    created() {



this.url=global.http;
document.title = '开通VIP会员';
var openidcode=this.$route.query.openidcode;
if(this.$route.query.active!=null){
this.active=parseInt(this.$route.query.active);
}
var uid=this.$route.query.uid;

if(openidcode==null){
     var openid=localStorage.getItem('openid');
      if(openid==null){
Toast.loading({
  message: '加载中...',
  forbidClick: true,
  duration:0
});

    window.location.href=global.http+"/api/login?url="+lujing
      }
}else{
    localStorage.setItem('openid',openidcode);
    localStorage.setItem('uid',uid);

}
		  
		  
        var openid=localStorage.getItem('openid');
         var uid=localStorage.getItem('uid');
         var that=this;

        this.$axios.get(global.http+'/vip/vipinfo',
        ).then(
            (response) => {
    that.data=response.data;
    }
    )  


    this.$axios.post(global.http+'/card/vip',{openid:localStorage.getItem('openid')}
        ).then(
            (res) => {
that.yhj=res.data;
that.sjc=res.data.jz;
setInterval(function(){
 that.sjc--;
that.djs=that.daojishi(that.sjc);
},1000);



    }
    )  


    /*
    this.$axios.post(global.http+'/tool/viplist').then(
            (res) => {
that.vipuser=res.data;


    }
    )  
*/




this.$axios.get(global.http+'/vip/user?openid='+localStorage.getItem('openid')).then(
            (response) => {
    that.vip=response.data;
if(response.data!=null){
       localStorage.setItem('user_vip',JSON.stringify(response.data));
   //  this.$router.push("/user/up");

 let timestamp = Math.floor(Date.now() / 1000)

if(timestamp>Number(response.data.etime_sjc)){

}else{
    this.$router.push("/user/up");
}
}

     
    }
    )  





    },mounted(){
        if(this.$route.query.pos=='buy'){
setTimeout(function(){
 document.getElementById('buy').click();
},600)
        }


    },methods: {
        daojishi:function(val){
    
		var d= parseInt(val/60/60/24);
				d = d<10? '0'+d:d;
				var h= parseInt(val/60/60%24);
				h = h<10? '0'+h:h;
				var m=parseInt(val/60%60);
				m = m<10?'0'+m:m;
				var s=parseInt(val%60);
				s = s<10?'0'+s:s;
		    var	a=d+"天"+h+"时"+m+'分'+s+'秒';
            return a;
        },
        use:function(){
            if(this.yh_check==false){
this.yh_check=true;
this.data.forEach((v,k) => {
this.data[k].price=v.price-20;
});



            }else{
              this.yh_check=false;  
              this.data.forEach((v,k) => {
this.data[k].price=v.price+20;
});
            }

        },onSwiper () {

    },
    onSlideChange () {

    },
       qh:function(val){
      this.active=val;
    },
buyvip:function(){
    let that=this;
console.log(that.data[that.active].id)
const tip1=Toast.loading({
  message: '开通中...',
  forbidClick: true,
  duration:0
});
this.$axios.post(global.http+'/vip/vbuy',{openid:localStorage.getItem('openid'),vid:that.data[that.active].id,r:that.r,yhj:that.yh_check}
        ).then(
            (res) => {
 if(res.data.code==1){
       tip1.clear();
     that.pay(res.data.v_s_id);
 }
   
    }
    )  

},pay:function(v_s_id){
  const tip2=Toast.loading({
  message: '等待支付中...',
  forbidClick: true,
  duration:0
});

   var that=this;
        this.$axios.get(global.http+'/vip/wxzf?v_s_id='+v_s_id+'&openid='+localStorage.getItem('openid')).then((response) => {
             tip2.clear();
   that.zf=response.data;


     WeixinJSBridge.invoke(
       'getBrandWCPayRequest',that.zf,
       function(res){
           if(res.err_msg == "get_brand_wcpay_request:ok" ) {
 

  

Toast({
type:'success',
message: '开通成功',
  forbidClick: true,
  duration:1000,
  onClose:function(){
      location.href="/"+lujing;
  }
});

           }
       }
   );



    })

}

    },

}
</script>



<style>
body {
    padding-bottom: 0rem;
}

</style>




<style lang="less"  scoped>

.vip {
   margin-bottom: 0rem;


}

.tp{
img{width:100%;display: block;}

}

@keyframes rowup {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
    100% {
        -webkit-transform: translate3d(0, -3.07rem, 0);
        transform: translate3d(0, -3.07rem, 0);
        display: none;
    }
}

.vip__comment{
  height: 3.07rem;
  overflow: hidden;box-shadow: 0px -17px 13px -2px rgba(255,255,255,0.46) inset;
-webkit-box-shadow: 0px -17px 13px -2px rgba(255,255,255,0.46) inset;
-moz-box-shadow: 0px -17px 13px -2px rgba(255,255,255,0.46) inset;
  background:#fff;margin:.1rem;padding:.1rem;border-radius: .05rem;
   position: relative;
.vip__comment-item{
   -webkit-animation: 10s rowup linear infinite normal;
    animation: 10s rowup linear infinite normal;
    position: relative;
    padding: .06667rem 0;
    border-bottom: .01333rem solid #ddd;
    margin-top: .03rem;
.vip__comment-info {
    display: flex;
    align-items: center;
    margin-bottom: .13333rem;
.vip__comment-avatar {
    width: .3rem;
    height: .3rem;
    margin-right: .1rem;
    border-radius: 50%;
}
.vip__comment-name {
    font-size: .15rem;
    color: #4c4b58;
}

}

.vip__comment-content{
    font-size: .14rem;
    line-height: .24rem;
    color: #4c4b58;
    text-align: justify;
    word-break: break-all;
}


}


}

.imgCont{
width:100%;box-sizing: border-box;
padding:.06rem;
img{width:100%;height: 1rem;}

}


  .s1 {
        width: 100%;
        height: 100%;
 
        .swiper-slide {
      background: #fff;
border-radius: .07rem;
      margin: .05rem;

      .testedPeople{
           font-size: .12rem;color:#fff;
           margin-top:-.19rem;position: relative;
           background: #00000082;margin-bottom: .0rem;
      }
.desc{font-weight: bold;padding-left: 0.04rem;margin-bottom: 0.14rem;overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;}

.vs img{width: 100%;display: block;}
        }

        .swiper-wrapper{
		transition-timing-function: linear !important;
	}

    }

.gd{width:94%;margin-left: 3%;background: #bed6f3;padding-bottom: .14rem;
border-radius: .1rem;
.gdt{text-align: center;font-size: 0.16rem;color:#102036;font-weight: bold;
padding-top: 0.1rem;}
}

.s2{
  width: 90%;
     margin-top: .1rem;padding-bottom: 0.24rem;
     .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        border-radius: 10px;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;

    align-items: center;
	  transition: 300ms;
	 
        img{width: 100%;border-radius: 10px;}
      }
 .swiper-pagination{margin-bottom:-0.13rem;}


}

.s3{
  width: 100%;
     margin-top: 0rem;padding-bottom: 0.1rem;
     .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;

    align-items: center;
	  transition: 300ms;
	 
        img{width: 100%;border-radius: 0px;display: block;}
      }
.swiper-pagination{margin-bottom:-0.1rem;


}


}


.vip__description{color:#fff;padding:.18rem;padding-bottom: 0.3rem;line-height: 0.23rem;
.vip__description-title{text-align: center;font-size: 0.18rem;font-weight: bold;margin-bottom: 0.1rem;}

}







    .btn {
        height: 40px;
        width: 20px;
        background-size: contain;
    }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
.vip__wrap{
    min-height:100vh;background-color:#112035;
    padding-bottom: 0rem;
}

.vip__wrap .vip__footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    z-index: 10;
}



.vip__wrap .vip__footer .vip__footer-button{
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: .70667rem;
    cursor: pointer;
}
@media screen and(min-width:600px) {

.vip__wrap .vip__footer .vip__footer-button{
    display: flex;
    position: absolute;
    bottom: 0;
 
    width: 5.35rem;
    height: .70667rem;
    cursor: pointer;
}

}


.vip__wrap .vip__footer .vip__footer-button .vip__button-home{
    width: .98667rem;
    height: .61333rem;
    margin-top: .09333rem;
    background: #fff url(//static.xinli001.com/cp/static/img/icon-home.865c628.png) no-repeat 50%;
    background-size: .4rem .52rem;
    border-top-left-radius: .24667rem;
}
.vip__wrap .vip__footer .vip__footer-button .vip__button-home span{
    display: block;
    height: 100%;
}
.vip__wrap .vip__footer .vip__footer-button .vip__button-buy{
    flex: 1;
    text-align: center;
    height: .70667rem;
    line-height: .7rem;
    margin-left: -.09333rem;
    border-radius: .34667rem .34667rem 0 0;
    background: linear-gradient(
1turn
,#f13fff,#ff77eb 72%,#ff97f0);
    font-size: .22rem;
    color: #fff;
}
.vip__wrap .vip__footer .vip__footer-button .vip__button-buy .vip__renew{
    position: relative;
    width: 100%;
    height: 100%;
}
.vip__wrap .vip__footer .vip__footer-button .vip__button-buy .vip__renew .vip__renew-price.is-ordinary{
    padding-left: 0;
    justify-content: center;
}
.vip__wrap .vip__footer .vip__footer-button .vip__button-buy .vip__renew .vip__renew-price span{
    font-size: .3rem;
}



.copyright {
    margin: .2rem 0 .02rem;
    position: relative;
    left: 0;
    background: transparent;
    font-size: .14rem;
    line-height: .16rem;
    padding: .08rem .1rem;
    color: #999;
    text-align: center;
    word-break: break-all;
}

.swiper-pagination-bullet {
    width: 22px;
    height: 22px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 1;
}


.switch-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    width: 100%;
    font-size: 18px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    margin: 0;
    list-style: none;
    display: block;
    text-align: center;
    background-color: #fff;
    left: 0;
    right: 0;
}
.switch-bar div {
    display: inline-block;
    font-size: .14rem;
    cursor: pointer;padding-top: 10px;padding-bottom: 5px;
margin-right: .14rem;
 color:#999;
}




.hyk{ touch-action:pan-y;
padding-top: 30px;
}
.k1{
background: #d8c0af;
}

.k2{
background: #d5dbe4;
}

.k3{
background: #e6b36c;
}

.k0{
background: #e8cccb;
}

.switch-bar .active {
    border-bottom: 3px solid #fc6935;    font-size: .15rem;color:#000;font-weight: bold;
}



.cardbg {
    padding: 10px 15px;box-sizing: content-box;
/*
    background-size: 100%;
    background-position: top;   
    
    -webkit-box-shadow: 0px 0px 10px -2px rgb(150 150 150);
    -moz-box-shadow: 0px 0px 10px -2px rgba(150, 150, 150, 1);
    box-shadow: 0px 0px 10px -2px rgb(150 150 150);
    border-radius: 25px;
*/

}
.ptcard {
/*
    background-image: url(/images/k0.png); 
*/
}
.cardbg  img{width: 100%;  

 }
.cardbg {
    width: 3.2rem;margin:0px auto;
    background-size: cover;
    background-position: top;

    border-radius: 25px;
}
.van-tabs{margin-top: 0rem;}
.tab-content.current {
    display: block;
    overflow: auto;
}



.mainContent {
    background-color: #fff;
    position: relative;
    z-index: 100;
    margin: auto;
margin-top:-0.9rem;

    width: 100%;
box-shadow: -3px -6px 20px -4px rgba(103,103,103,0.75);
-webkit-box-shadow: -3px -6px 20px -4px rgba(103,103,103,0.75);
-moz-box-shadow: -3px -6px 20px -4px rgba(103,103,103,0.75);


}

#tab-2 {
    margin-bottom: 30px;
    padding-bottom: 30px;
}
.tab-content{
    display: block; height:5rem;
    overflow: scroll;overflow-y: visible;
}
.type-wrap .type-item {
    width: 100%;
    margin: 0;
}
.type-wrap .type-item {
    /* width: 380px; */
    width: 100%;

    background: #fff;
    position: relative;

    text-align: center;
    -webkit-box-shadow: 0 -10px 20px 0 rgb(0 0 0 / 50%);
    box-shadow: 0 -10px 15px -10px rgb(0 0 0 / 50%);
    -webkit-transition: all 1s;
    transition: all 1s;
}


.bottompay {
    width: 100%;
}
.bottompay {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: none;
 
    z-index: 1000;
    margin: auto;
 
}
.bottompay .inner {
    width: 100%;display: flex;    justify-content: space-between;
    padding: 0px;box-sizing: border-box;    align-items: flex-end;
   

}
.left-price-label {
 display: flex;height: .45rem; 
    width: 1.65rem;margin-top: 0rem;background: #fff;
     align-items: flex-end;justify-content: center;
     border-top: 1px solid #e6e6e6;
    p{margin-right: 0.04rem;}
    .yj{font-size: 0.13rem;
       color:#999;position:relative;top:-0.02rem;
    span{font-size: 0.18rem; text-decoration: line-through;}
    }
}
.right-price-label {
 flex-grow: 1;
width: 0;    background: #f44336  !important;
text-align: center;height: .45rem;line-height: 0.45rem;font-size: 0.18rem;color:#fff;

border-top: 1px solid #f44336 ;

 .text{
    -webkit-animation: fd 1.3s linear infinite;
    animation: fd 1.3s linear infinite;
    display: flex;
    justify-content: center;
    align-items: center;
}

}
.btn-buy1 {

  
    
}

@media (max-width: 768px){
.cardbg {
    height: 195px;
}
}


@keyframes fd {
    0% {
    transform: scale(1);
}
50% {
    transform: scale(0.9);
}
100% {
    transform: scale(1);
}
}





</style>